var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.href ? "a" : "button",
    _vm._g(
      {
        tag: "component",
        staticClass: "ax-powerbar__icon-button",
        attrs: {
          id: _vm.id,
          href: _vm.href,
          title: _vm.title,
          "aria-label": _vm.title
        }
      },
      _vm.onClick ? { click: _vm.onClick } : {}
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }